import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box,
  Grid,
  Link,
  Button,
  useTheme,
  useMediaQuery
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import GradientBackground from '../components/GradientBackground';
const ContactPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const contactInfo = {
    email: 'contacto@liderdist.com',
    phone: '1552218205'
  };

  const whatsappLink = `https://wa.me/549${contactInfo.phone}`;
  const emailLink = `mailto:${contactInfo.email}`;

  return (
    <GradientBackground>
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Contactanos
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Estamos aquí para ayudarte. No dudes en contactarnos por cualquier consulta.
          </Typography>
        </Box>

        <Grid container spacing={4} sx={{ mb: 4 }}>
          {/* Email Section */}
          <Grid item xs={12} md={6}>
            <Box sx={{ 
              p: 3, 
              textAlign: 'center',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2
            }}>
              <EmailIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              <Typography variant="h6" gutterBottom>
                Correo Electrónico
              </Typography>
              <Link 
                href={emailLink}
                underline="hover"
                sx={{ display: 'block', mb: 2 , fontSize: { xs: '1rem', md: '1.2rem' }}}
              >
                {contactInfo.email}
              </Link>
              <Button
                variant="contained"
                startIcon={<EmailIcon />}
                href={emailLink}
                fullWidth={isMobile}
              >
                Enviar Email
              </Button>
            </Box>
          </Grid>

          {/* Phone/WhatsApp Section */}
          <Grid item xs={12} md={6}>
            <Box sx={{ 
              p: 3, 
              textAlign: 'center',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2
            }}>
              <PhoneIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              <Typography variant="h6" gutterBottom>
                Teléfono / WhatsApp
              </Typography>
              <Link 
                href={`tel:${contactInfo.phone}`}
                underline="hover"
                sx={{ display: 'block', mb: 2 , fontSize: { xs: '1rem', md: '1.2rem'} }}
              >
                {contactInfo.phone}
              </Link>
              <Button
                startIcon={<WhatsAppIcon />}
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                fullWidth={isMobile}
                sx={{
                  backgroundColor: '#14c700 !important',
                  '&:hover': {
                    backgroundColor: '#128C7E !important'
                  },
                  color: 'white !important',
                  fontFamily: 'Arial, sans-serif !important',
                }}
              >
                Contactar por WhatsApp
              </Button>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Horario de atención: Lunes a Viernes de 9:00 a 18:00
          </Typography>
        </Box>
      </Paper>
    </Container>
    </GradientBackground>
  );
};

export default ContactPage; 